import { render, staticRenderFns } from "./DropdownTitle.vue?vue&type=template&id=1c1b50f7&"
import script from "./DropdownTitle.vue?vue&type=script&lang=js&"
export * from "./DropdownTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports